import React from 'react'

import { graphqlClient } from 'utils/graphql'
import { UserLanguages } from '../types/graphql/schema'

import { userContext } from './user'
import { translations as translationStrings } from '../generated/translations'


export const Languages = {
  en: 'English',
  zh: '中文',
  fr: 'Français',
  pt: 'Português',
  es: 'Español',
  ja: '日本語'
} as {[key in UserLanguages]: string}

export const langSwitchContext = React.createContext<[UserLanguages, (l: UserLanguages) => void]>([UserLanguages.en, () => {}])

export function useLangSwitch(): [UserLanguages, (l: UserLanguages) => void] {
  const user = React.useContext(userContext)
  const [lang, setLang] = React.useState<UserLanguages>((user.data?.language || UserLanguages.en) as UserLanguages)
  
  React.useEffect(() => {
    if (!user.data || user.data.language === lang) return
    setLang(user.data.language)
  }, [user.data])
  
  return [
    lang,
    (newLanguage: UserLanguages) => {
      // If user is not logged in, just change the language
      if (!user.data) {
        setLang(newLanguage)

      // If user is logged in, set it in the profile
      } else {
        graphqlClient.chain.mutation
          .updateCurrentUser({language: newLanguage})
          .execute({__scalar: 1})
          .then(() => user.refetch())
      }
    }
  ]
}


export const translationsContext = React.createContext<(key: string) => string>(() => '')

export function useTranslations() {
  const [lang] = React.useContext(langSwitchContext)
  
  return (key: string) => {
    if (!lang) return ''
    key = key.toLowerCase()
    const translation = translationStrings[key]
    if (translation === undefined) {
      console.error(`Translation for key "${key}" not found`)
      return key
    }
    return translation[lang] || translation.en
  }
}
